
import React from "react";
import { Link } from "react-router-dom";
import {
  FaLightbulb,
  FaBuilding,
  FaTachometerAlt,
  FaRegLightbulb,
  FaRegBuilding,
} from "react-icons/fa";

function LeftPanel() {
  return (
    // <div className="w-[20%] bg-[#002060] text-white flex flex-col py-6 px-0">
       <div className="hidden lg:block lg:w-[20%] bg-[#002060] text-white flex flex-col py-6 px-0">  

      <div className="flex flex-col items-center mb-6">
  <h2 className="text-3xl text-center text-[#98a5be]">SUMMARY</h2>
  <hr className="border-t border-gray-400 w-full max-w-[10rem] mt-2" />
</div>


<div className="flex flex-col items-center space-y-0">
  {/* Metric 1 */}
  <div className="flex items-center  relative w-full">
    <div className="flex items-center mx-14 ">
      <div className="p-3">
        <FaLightbulb className="text-[#7ABC32]" size={20} />
      </div>
      <span className="ml-3 text-[#98a5be] text-md">12 NMI</span>
    </div>
    <div className="absolute right-0 top-0 h-full w-1 bg-[#7ABC32]" />
  </div>

  {/* Metric 2 */}
  <div className="flex items-center relative w-full">
    <div className="flex items-center mx-14">
      <div className="p-3">
        <FaRegBuilding className="text-[#7ABC32]" size={20} />
      </div>
      <span className="ml-3 text-[#98a5be] text-md">5 Sites</span>
    </div>
    <div className="absolute right-0 top-0 h-full w-1 bg-[#7ABC32]" />
  </div>

  {/* Metric 3 */}
  <div className="flex items-center  relative w-full">
    <div className="flex items-center mx-14">
      <div className="p-3">
        <FaTachometerAlt className="text-[#7ABC32]" size={20} />
      </div>
      <span className="ml-3 text-[#98a5be] text-md">19 Meters</span>
    </div>
    <div className="absolute right-0 top-0 h-full w-1 bg-[#7ABC32]" />
  </div>
</div>

<Link to="/bulk-reporting">
  <button className="w-full flex mt-10 overflow-hidden transition text-center">
    {/* Left (text) section */}
    <div className="flex-1 bg-[#305d4d] text-[#002060] py-5 flex flex-col justify-center items-start pl-14">

      <div className="text-sm text-white leading-tight ml-3">Go To</div>
      <div className="text-lg text-white font-semibold ml-3">REPORTS</div>
    </div>

    {/* Right (arrow) section */}
    <div className="bg-[#7ABC32] flex items-center justify-center px-5 py-4">
  <svg width="50" height="24" viewBox="0 0 80 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0" y1="12" x2="60" y2="12" stroke="white" strokeWidth="4" />
    <polygon points="60,4 80,12 60,20" fill="white" />
  </svg>
</div>
  </button>
</Link>

<Link to="/dashboard">
  <button className="w-full flex py-2 overflow-hidden transition">
    {/* Left (text) section */}
    <div className="flex-1 bg-[#305d4d] text-[#002060] py-5 flex flex-col justify-center items-start pl-14">

      <div className="text-sm text-white leading-tight ml-3">Go To</div>
      <div className="text-lg text-white font-semibold ml-3">DASHBOARD</div>
    </div>

    {/* Right (arrow) section */}
    <div className="bg-[#7ABC32] flex items-center justify-center px-5 py-4">
  <svg width="50" height="24" viewBox="0 0 80 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0" y1="12" x2="60" y2="12" stroke="white" strokeWidth="4" />
    <polygon points="60,4 80,12 60,20" fill="white" />
  </svg>
</div>

  </button>
</Link>


</div>
  );
}

export default LeftPanel;
 